<!--
    ==============================
    템플릿 실제 사용되는 페이지:
    스토어 메인, 기획전
    ==============================
 -->
<template>
    <div class="exhibition-grid-container">
        <!-- 제목,내용 있는 썸네일 그리드 -->
        <div class="exhibition-grid">
            <a class="box" href="#" onclick="return false;">
                <div class="thumbnail">
                    <!-- 슬라이더 전용 Lazy Load 썸네일 -->
                    <span v-if="listStyle === 'slide'" class="image">
                        <span :data-background="index % 2 === 0 ? '/images/sample/product-thumbnail-xlarge.jpg' : '/images/sample/product-thumbnail-xlarge2.jpg'" class="swiper-lazy"></span>
                        <div class="swiper-lazy-preloader"></div>
                    </span>
                    <!-- 일반 리스트페이지용 썸네일 -->
                    <span v-else class="image">
                        <span v-if="index % 2 === 0" style="background-image:url('/images/sample/product-thumbnail-xlarge.jpg'); opacity: 1;"></span>
                        <span v-else style="background-image:url('/images/sample/product-thumbnail-xlarge2.jpg'); opacity: 1;"></span>
                    </span>
                    <span class="img"></span>
                </div>
                <div class="context">
                    <span class="title">집콕 맞춤형 가구 인테리어!</span>
                    신년맞이 최대 10% 쿠폰
                </div>
            </a>
        </div>
        <!-- 나머지 기본 썸네일 그리드 -->
        <div v-for="(item, index) in items" class="exhibition-grid">
            <a class="box" href="#" onclick="return false;">
                <div class="thumbnail">
                    <!-- 슬라이더 전용 Lazy Load 썸네일 -->
                    <span v-if="listStyle === 'slide'" class="image">
                        <span :data-background="index % 2 === 0 ? '/images/sample/product-thumbnail-xlarge.jpg' : '/images/sample/product-thumbnail-xlarge2.jpg'" class="swiper-lazy"></span>
                        <div class="swiper-lazy-preloader"></div>
                    </span>
                    <!-- 일반 리스트페이지용 썸네일 -->
                    <span v-else class="image">
                        <span v-if="index % 2 === 0" style="background-image:url('/images/sample/product-thumbnail-xlarge.jpg'); opacity: 1;"></span>
                        <span v-else style="background-image:url('/images/sample/product-thumbnail-xlarge2.jpg'); opacity: 1;"></span>
                    </span>
                    <span class="img"></span>
                </div>
                <!-- 마지막 그리드 일때만 표시-->
                <div v-if="index === items.length - 1" class="context">
                    +1230
                </div>
            </a>
        </div>
    </div>
</template>

<script>
export default{
	components: {
	},
    props: {
        index: {
            type: Number,
        },
        listStyle:{
            type: String,
            default: 'page',
        }
    },
    data: () => {
        return{
            items: new Array(4)
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>
<style lang="scss" scoped>
    // Variables
    $font-montserrat: 'Montserrat','Noto Sans KR','Apple SD Gothic Neo',Helvetica,sans-serif,Arial;

    // Styles
    .exhibition-grid-container{
    	box-sizing: border-box; margin: 0 -18px;
    	&::after { content: ''; display: block; clear: both; }
    }
    .exhibition-grid{
        float: left; padding: 18px; width: 25%;
        .box { display: block; overflow: hidden; position: relative; border-radius: 15px; }
        .thumbnail{
            background-color: #bfbfbf;
            .image { -webkit-transition: all ease .3s; transition: all ease .3s; }
            .image span { opacity: 0; }
            .image span.swiper-lazy-loaded { animation: thumbnail-fade-in .6s ease forwards; }
        }
        .context{
            z-index: 2; position: absolute; left: 0; bottom: 0; padding: 34px 38px; width: 100%; font-size: 16px; font-weight: 300; color: #ffffff; background: rgba(0,0,0,.6);
            .title { display: block; margin-bottom: 6px; font-size: 24px; font-weight: 700; }
        }
        .box:hover .thumbnail .image{ -webkit-transform: scale(1.05); transform: scale(1.05); }
        &:not(:first-child) .context { display: flex; align-items: center; justify-content: center; top: 0; font-family: $font-montserrat; font-size: 60px; font-weight: 200; }
        &:first-child { width: 50%; }
        @for $i from 2 through 5{
            &:nth-child(#{$i}) .thumbnail .image span.swiper-lazy-loaded{
                animation-delay: 0.1s * $i - 0.1;
            }
        }
    }
    @media(max-width:1200px){
    	.exhibition-grid-container { margin: -10px; }
        .exhibition-grid{
            padding: 10px;
            .context{
                font-size: 13px; opacity: 1; -webkit-transform: none; transform: none;
                .title { font-size: 16px; }
            }
            &:not(:first-child) .context { font-size: 22px; }
        }
    }
    @media(max-width:768px){
    }
    @media(max-width:600px){
    	.exhibition-grid-container { margin: -5px; }
        .exhibition-grid{
            padding: 5px; width: 25%;
            .box { border-radius: 12px; }
            .context{
                padding: 16px 20px; font-size: 12px;
                .title { margin-bottom: 4px; font-size: 15px; }
            }
            &:not(:first-child) .context { font-size: 20px; }
            &:first-child { width: 100%; }
        }
    }
</style>
